const firebaseConfig = {
    apiKey: "AIzaSyBZrn2FQF8QKd3LHqp6qS7N1P9CUeaDzgM",
    authDomain: "crypto-tracker-4119.firebaseapp.com",
    projectId: "crypto-tracker-4119",
    storageBucket: "crypto-tracker-4119.appspot.com",
    messagingSenderId: "941160964010",
    appId: "1:941160964010:web:3aa5bb41f8c52de7a415d3"
  };

  export default firebaseConfig;